import { render, staticRenderFns } from "./QuickSelectSlot.vue?vue&type=template&id=2b028ac4&scoped=true"
import script from "./QuickSelectSlot.vue?vue&type=script&lang=ts"
export * from "./QuickSelectSlot.vue?vue&type=script&lang=ts"
import style0 from "./QuickSelectSlot.vue?vue&type=style&index=0&id=2b028ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b028ac4",
  null
  
)

export default component.exports